import { Component } from '@angular/core';
import { AppState } from '../../config/state';

@Component({
  selector: 'page-checkout',
  templateUrl: 'checkout.html',
})
export class CheckoutPage {
  menuSide: string = "left";

  constructor(public state: AppState) {
    this.state.burgerMenu && this.state.burgerMenu.menuSide ? this.menuSide = this.state.burgerMenu.menuSide : this.menuSide = "hidden";
  }
}



// WEBPACK FOOTER //
// ./src/pages/checkout/checkout.ts